module.exports = __webpack_public_path__ + "media/images/icons/twotone/lock-613ad35a2837f3a9450032afa983bf15.svg";